// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCApiGatewayServiceClientsEnumsRoleType } from './tCApiGatewayServiceClientsEnumsRoleType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersAccountModelsSharedContactAccountDataModel {
    'id'?: number | null;
    'roleType'?: TCApiGatewayServiceClientsEnumsRoleType;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'phoneNumber'?: string | null;
    'altPhoneNumber'?: string | null;
    'email'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersAccountModelsSharedContactAccountDataModel>> = [
        {
            "name":     "id",
            "baseName": "id",
            "type":     "number"
        },
        {
            "name":     "roleType",
            "baseName": "roleType",
            "type":     "TCApiGatewayServiceClientsEnumsRoleType"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "altPhoneNumber",
            "baseName": "altPhoneNumber",
            "type":     "string"
        },
        {
            "name":     "email",
            "baseName": "email",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersAccountModelsSharedContactAccountDataModel.attributeTypeMap;
    }
}
